export const DELIVERY_ICONS = {
    brandShop: "productDeliveryBrandShopIcon",
    pvz: "productDeliveryPickupIcon",
    courier: "productDeliveryCourierIcon",
}
